import React from 'react';
import { ScrollReveal } from './shared';

const HowWeWorkSection = () => {
  const steps = [
    {
      number: '01',
      title: 'We validate.',
      description: 'We quantify opportunity, test assumptions, and surface hidden risk before major resources are deployed.',
    },
    {
      number: '02',
      title: 'We design.',
      description: 'We build the strategy, positioning, and roadmap required to move confidently.',
    },
    {
      number: '03',
      title: 'We activate.',
      description: 'We help mobilize leadership alignment, strategic partnerships, and growth-enabling support to bring the strategy to life.',
    },
  ];

  return (
    <section className="section-spacing bg-[#F1F5F9]" data-testid="how-we-work-section">
      <div className="container-luxury">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center mb-16">
            <p className="overline mb-4">Our Process</p>
            <h2 className="heading-section text-4xl sm:text-5xl text-[#0B1A2B] mb-6" data-testid="how-we-work-headline">
              Your path in three steps
            </h2>
            <p className="body-large">
              From insight to execution, APIG helps clients move with more confidence and less guesswork.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <ScrollReveal key={index} delay={index * 150}>
              <div data-testid={`process-step-${index + 1}`}>
                <div className="w-12 h-12 border-2 border-[#D97706] flex items-center justify-center mb-6">
                  <span className="text-[#D97706] font-serif text-lg font-medium">{step.number}</span>
                </div>
                <h3 className="font-serif text-2xl text-[#0B1A2B] mb-4">{step.title}</h3>
                <p className="text-[#334155] text-[0.9375rem] leading-relaxed">{step.description}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
